<template>
  <div
    class="obj-dialog fixed z-999"
    :style="{ width, height, top, left, right }"
    v-cockpitDrag
    id="viewDialog"
  >
    <div class="flex items-center obj-dialog-header">
      <!-- 标题 -->
      <div class="w-[calc(100%-101px)] text-white header pl-10px">{{ dialogForm.fileName }}</div>
      <!-- 退出全屏 -->
      <img
        v-if="isFullScreen || type === 'screen'"
        src="../../../assets/images/objInfo/shrink.png"
        alt=""
        class="ml-10px cursor-pointer img"
        @click="exitFullScreen"
      />
      <!-- 打开全屏 -->
      <img
        v-else
        src="../../../assets/images/objInfo/expand.png"
        alt=""
        class="ml-10px cursor-pointer img"
        @click="fullScreen"
      />
      <!-- 分屏 -->
      <img
        src="../../../assets/images/objInfo/split_screen2.png"
        alt=""
        class="ml-10px cursor-pointer img"
        @click="splitScreen(dialogForm)"
        v-if="type === 'dialog'"
      />
      <!-- 关闭弹窗 -->
      <div
        class="
          obj-dialog__close
          text-white
          w-36px
          h-36px
          iconfont
          icon-line-close
          text-center
          leading-36px
          ml-10px
          cursor-pointer
        "
        @click="close"
      ></div>
    </div>
    <div class="w-full h-[calc(100%-62px)] mt-10px">
      <fileView
        :dialogForm="dialogForm"
        :player="player"
        :standardId="standardId"
        @svgTrigger="svgTrigger"
      />
    </div>
  </div>
</template>

<script>
import fileView from './fileView'

export default {
  name: 'objDialog',
  components: { fileView },
  props: {
    dialogForm: {
      type: Object,
      defalut: '',
    },
    width: {
      type: String,
      defalut: '800px',
    },
    height: {
      type: String,
      defalut: '550px',
    },
    top: {
      type: String,
      defalut: '120px',
    },
    left: {
      type: String,
      defalut: '630px',
    },
    right: {
      type: String,
      defalut: '0px',
    },
    type: {
      type: String,
      defalut: 'dialog',
    },
    player: {
      type: Object,
      default: () => {},
    },
    module: {
      type: String,
      default: '',
    },
    standardId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFullScreen: false,
    }
  },
  methods: {
    svgTrigger(val) {
      this.$emit('svgTrigger', val)
    },
    // 分屏
    splitScreen(val) {
      this.$emit('splitScreen', val)
      this.close()
    },
    // 关闭对话框
    close() {
      this.$emit('closeObjInfo')
    },
    // 全屏
    fullScreen() {
      this.isFullScreen = true
      this.launchFullscreen(document.getElementById('viewDialog'))
    },
    // 判断各种浏览器，找到正确的方法
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
      $('.obj-dialog').width(window.screen.width).height(window.screen.height)
    },
    // 退出全屏
    exitFullScreen() {
      this.isFullScreen = false
      if (this.type === 'screen') {
        this.$emit('exitScreen', this.module)
        return
      }
      this.exitFullscreen()
      $('.obj-dialog').width(800).height(550)
    },
    // 判断浏览器种类
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
  },
  directives: {
    cockpitDrag: {
      bind(el, binding, vnode, oldVnode) {
        const odiv = el // 获取当前元素
        const dialogHeaderEl = el.querySelector('.obj-dialog-header')
        dialogHeaderEl.style.cssText += ';cursor:move;'

        dialogHeaderEl.onmousedown = (e) => {
          if (e.button === 0) {
            // 阻止穿透
            e.stopPropagation()
            // 无需触发拖动的元素
            const className = ['el-slider__button', 'icon-close', 'el-input__inner', 'img']
            // 算出鼠标相对元素的位置
            if (!_.isEmpty(_.intersection(className, e.target.className.split(' ')))) {
              return
            }
            // 获取点击元素路径列表
            const ePathList = e.path
            // 是否被'height-routerView'包裹
            const isRouterView = _.findIndex(ePathList, (item) => {
              return item.className === 'h-100 height-routerView'
            })
            const sliderWidth = isRouterView === -1 ? 0 : 200
            const sliderHeight = isRouterView === -1 ? 0 : 90
            const disX = e.clientX - odiv.offsetLeft
            const disY = e.clientY - odiv.offsetTop
            let left = ''
            let top = ''
            document.onmousemove = (element) => {
              // 阻止穿透
              element.stopPropagation()
              // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              left = element.clientX - disX
              top = element.clientY - disY
              // 绑定元素位置到positionX和positionY上面
              // 移动当前元素
              if (left < 0) {
                left = 0
              } else if (
                left >
                document.documentElement.clientWidth - odiv.offsetWidth - sliderWidth
              ) {
                left = document.documentElement.clientWidth - odiv.offsetWidth - sliderWidth
              }
              if (top < 0) {
                top = 0
              } else if (
                top >
                document.documentElement.clientHeight - odiv.offsetHeight - sliderHeight
              ) {
                top = document.documentElement.clientHeight - odiv.offsetHeight - sliderHeight
              }
              odiv.style.left = `${left}px`
              odiv.style.top = `${top}px`
            }
          }
          document.onmouseup = () => {
            document.onmousemove = null
            document.onmouseup = null
            document.onmouseout = null
          }
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.obj-dialog {
  background-image: var(--dialogBgImg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px;
  .header {
    background-image: var(--diyCardTitleBg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 36px;
    line-height: 40px;
  }
}
</style>
